const { createElem } = require('./helpers');
const bannerLeftImgSrc = require('../assets/images/layout-banner-left.svg');
const bannerRightImgSrc = require('../assets/images/layout-banner-right.svg');

class Banner {
  constructor(bannerSettings) {
    if (Object.prototype.hasOwnProperty.call(bannerSettings, 'heading')) {
      this.heading = bannerSettings.heading;
    }

    if (Object.prototype.hasOwnProperty.call(bannerSettings, 'subHeading')) {
      this.subHeading = bannerSettings.subHeading;
    }

    if (this.heading === undefined || this.subHeading === undefined) {
      throw new ReferenceError(
        'Error in custom banner settings'
      );
    }
  }

  buildHtml() {
    const frag = document.createDocumentFragment();

    const bannerWrapper = createElem('div', { class: 'banner banner--wrapper' });
    const bannerContent = createElem('div', { class: 'banner--content' });
    const bannerImgLeft = createElem('img', { class: 'banner--image', src: bannerLeftImgSrc, alt: '' });
    const bannerImgRight = createElem('img', { class: 'banner--image', src: bannerRightImgSrc, alt: '' });
    const bannerHeading = createElem('h1', { class: 'banner--heading' }, this.heading);
    const bannerSubHeading = createElem('h2', { class: 'banner--subheading' }, this.subHeading);

    frag.appendChild(bannerWrapper);
    bannerContent.appendChild(bannerHeading);
    bannerContent.appendChild(bannerSubHeading);
    bannerWrapper.appendChild(bannerImgLeft);
    bannerWrapper.appendChild(bannerContent);
    bannerWrapper.appendChild(bannerImgRight);

    return frag;
  }

  init() {
    const target = document.getElementById('top-header');

    if (!target) {
      throw new ReferenceError('Could not append banner');
    }

    target.insertBefore(this.buildHtml(), target.firstChild);
    return this;
  }
}

module.exports = Banner;


// WEBPACK FOOTER //
// ./modules/Banner.js